import { render, staticRenderFns } from "./Convos.vue?vue&type=template&id=42c082a8&"
import script from "./Convos.vue?vue&type=script&lang=js&"
export * from "./Convos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports